import { Breadcrumb, Button, Card, Col, Input, message, Row, Table } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link, RouteComponentProps } from 'react-router-dom';

import { Panel } from '../../components/Panel';
import { USER_PROLES_QUERY, USER_ROLE_PERMISSIONS_QUERY } from './constant';
import { UserPermission } from './type';

interface State {
  name: string;
  userPermissionIds: string[];
}

interface Props {}
type AllProps = RouteComponentProps<Props>;

const createUserRoleMutation = gql`
  mutation createUserRole($name: String!, $permissionIds: [ID]!) {
    createUserRole(name: $name, permissionIds: $permissionIds) {
      id
      name
      permissions {
        id
        description
        action
        resource
      }
    }
  }
`;

export class AddRole extends Component<AllProps, State> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      name: '',
      userPermissionIds: [],
    };
  }

  onUserRoleNameInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      name: e.target.value,
    });
  };

  onSelectChange = (selectedUserPermissionIds: string[]) => {
    this.setState({ userPermissionIds: selectedUserPermissionIds });
  };

  render() {
    const { name, userPermissionIds } = this.state;
    const permissionIds = userPermissionIds.map(id => Number(id));
    return (
      <div>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/role-permission-role/role/list`}>角色列表</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>添加角色</Breadcrumb.Item>
        </Breadcrumb>
        <Panel style={{ marginTop: 10 }}>
          <Card>
            <Row type={'flex'} align={'middle'} gutter={24}>
              <Col span={21}>
                <span>角色名称：</span>
                <Input style={{ width: 300 }} value={name} onChange={this.onUserRoleNameInput} />
              </Col>
              <Col span={3}>
                <Mutation
                  mutation={createUserRoleMutation}
                  variables={{ name, permissionIds }}
                  refetchQueries={[{ query: USER_PROLES_QUERY }]}
                >
                  {(createUserRole, { loading }) => {
                    return (
                      <>
                        <Button
                          type="primary"
                          loading={loading}
                          onClick={async () => {
                            try {
                              if (name && userPermissionIds && userPermissionIds.length) {
                                await createUserRole();
                                message.success('保存成功');
                                this.props.history.goBack();
                                return;
                              }
                              message.error('请将信息填写完整！');
                            } catch (error) {
                              message.error(`${error.message}`);
                            }
                          }}
                        >
                          保存
                        </Button>
                      </>
                    );
                  }}
                </Mutation>
              </Col>
            </Row>
          </Card>
          <Query query={USER_ROLE_PERMISSIONS_QUERY}>
            {({ loading, error, data }) => {
              if (error) return <div>{error.message}</div>;
              const allUserPermissions = (data && data.userRolePermissions) || [];
              return (
                <Table<UserPermission>
                  loading={loading}
                  dataSource={allUserPermissions}
                  rowSelection={{ selectedRowKeys: userPermissionIds, onChange: this.onSelectChange }}
                  rowKey={row => `${row.id}`}
                  pagination={false}
                >
                  <Table.Column dataIndex="id" title="权限ID" key="id" />
                  <Table.Column dataIndex="description" title="描述" key="description" />
                  <Table.Column dataIndex="action" title="行为" key="name" />
                  <Table.Column dataIndex="resource" title="来源组件" key="resource" />
                </Table>
              );
            }}
          </Query>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/rolePermission/AddRole.tsx